import React, { useContext, useEffect, useState } from 'react'
import { ProjectContext } from '../../../../../context/ProjectContext'
import { timeAgo } from '../../../../../utils'
import { useCustomFetch } from '../../../../../hooks/useCustomFetch'
import AddPinkIcon from '../../../../icons/AddPink'
import { useNavigate } from 'react-router-dom'
import { Facilitator } from './facilitator'
import { Popover, PopoverContent, PopoverTrigger } from '../../../../ui/popover'
import { Button } from '../../../../ui/button'

export function Facilitators ({ overviewDesign = true }) {
  const { project, setProject } = useContext(ProjectContext)
  const [facilitators, setFacilitators] = useState([])
  const [users, setUsers] = useState([])
  const navigate = useNavigate()
  const customFetch = useCustomFetch()

  useEffect(() => {
    const getUsers = async () => {
      const facilitatorsDb = []
      const response = await customFetch(`/getUsersByWorkspace/${project.workspace_id}`, 'GET', null)
      for (const facilitator of project.facilitators) {
        const userIndex = response.users.findIndex(user => user.id === facilitator)
        if (userIndex === -1) return console.log('Facilitator not found in users')
        facilitatorsDb.push(response.users[userIndex])
        response.users.splice(userIndex, 1) // 2nd parameter means remove one item only
      }
      setUsers(response.users)
      setFacilitators(facilitatorsDb)
    }
    getUsers()
  }, [])

  async function addFacilitator (userId) {
    const user = users.find(user => user.id === userId)
    setUsers(prevUsers => prevUsers.filter(user => user.id !== userId))
    setFacilitators(prevFacilitators => [...prevFacilitators, user])
    setProject(prevProject => ({ ...prevProject, facilitators: [...prevProject.facilitators, userId] }))
    await customFetch('/updateProjectFacilitators', 'PUT', { projectId: project.id, facilitators: [...facilitators.map(user => user.id), userId] })
  }

  async function removeFacilitator (userId) {
    const facilitator = facilitators.find(user => user.id === userId)
    setFacilitators(prevFacilitators => prevFacilitators.filter(user => user.id !== userId))
    setUsers(prevUsers => [...prevUsers, facilitator])
    setProject(prevProject => ({ ...prevProject, facilitators: prevProject.facilitators.filter(user => user !== userId) }))
    await customFetch('/updateProjectFacilitators', 'PUT', { projectId: project.id, facilitators: facilitators.filter(user => user.id !== userId).map(user => user.id) })
  }

  return (
    <div className={`w-full ${overviewDesign ? "pb-[28px] border-b border-[#e4e4e4]" : ""}`}>
      <div className="flex items-center gap-2 mb-3">
        <p className="text-[#62708d] text-xs font-bold font-['Manrope'] uppercase tracking-wider mt-[1px]">Facilitators</p>
        <Popover>
          <PopoverTrigger asChild>
            <Button 
              variant="ghost" 
              size="icon"
              className="h-5 w-5 rounded-full hover:bg-gray-100 p-0"
              disabled={!users.length}
            >
              <AddPinkIcon />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-80 p-0" align="start">
            {!users.length ? (
              <div className="p-4 text-sm">
                Please add team members to this workspace to add other facilitators.
                <Button 
                  variant="link" 
                  className="h-auto p-0 text-linkBlue font-semibold" 
                  onClick={() => navigate('/dashboard/team')}
                >
                  Team Settings
                </Button>
              </div>
            ) : (
              <div className="py-2">
                {users.map((user, index) => user.workspace.joined_at && (
                  <button
                    key={user.id}
                    onClick={() => addFacilitator(user.id)}
                    className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors ${
                      index < users.length - 1 ? 'border-b border-[#e4e4e4]' : ''
                    }`}
                  >
                    <img 
                      className="w-8 h-8 rounded-full border border-grey-200" 
                      src={user.picture} 
                      alt={user.name}
                    />
                    <div className="flex flex-col items-start">
                      <p className="text-[#3f424a] text-sm font-semibold">{user.name}</p>
                      <p className="text-[#62708d] text-xs">Joined {timeAgo(user.workspace.joined_at)}</p>
                    </div>
                  </button>
                ))}
              </div>
            )}
          </PopoverContent>
        </Popover>
      </div>

      <div className='flex flex-wrap gap-2'>
        {Array.isArray(facilitators) && facilitators.map((facilitator) => (
          <Facilitator key={facilitator.id} facilitator={facilitator} removeFacilitator={removeFacilitator} />
        ))}
      </div>
    </div>
  )
}
